import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { setGroup, updateScenario, updateTime } from "../../redux/actions";
import { getTimer, updateStats } from "../../utils/helpers";

/**
 * Botón "Continuar" con estilo start-game-cta y la misma lógica de tiempo/escenario que NextButton.
 */
function Scenario2NextCta({
	navigateTo,
	navigateToAfter,
	activeScenario,
	label = "Continuar",
	className = "",
	canContinue = true,
	lockedTitle = "Completa el paso anterior para continuar",
}) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const scenario = activeScenario || location?.state?.activeScenario;
	const [loading, setLoading] = useState(false);

	const locked = !canContinue;

	async function handleClick(e) {
		e.preventDefault();
		if (loading || locked) return;
		setLoading(true);
		const raw = getTimer();
		const timeNum =
			raw !== null && raw !== ""
				? Number(raw)
				: parseInt(group?.time ?? 0, 10);
		const time = Number.isFinite(timeNum) ? timeNum : 0;
		const nextGroup = {
			...group,
			actualScenario: scenario || group?.actualScenario,
			time,
			lastVisited: navigateTo,
			finished: false,
		};
		dispatch(updateTime(time));
		dispatch(updateScenario(scenario));
		dispatch(setGroup(nextGroup));
		try {
			await updateStats(nextGroup);
		} catch {
			/* la partida sigue; el estado local ya está alineado */
		}
		await new Promise((r) => requestAnimationFrame(() => r()));
		navigate(navigateTo, {
			state: { navigateTo: navigateToAfter, activeScenario: scenario },
		});
	}

	return (
		<button
			type="button"
			className={`start-game-cta sg5-cta ${className}`.trim()}
			onClick={handleClick}
			disabled={loading || locked}
			aria-busy={loading}
			title={locked ? lockedTitle : undefined}
		>
			{loading ? (
				<span className="start-game-cta-spinner" aria-hidden />
			) : (
				<img className="start-game-cta-icon" src={flechaAvanzar} alt="" />
			)}
			{loading ? "…" : label}
		</button>
	);
}

export default Scenario2NextCta;
